import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Heart, Shield, Users, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full px-2 py-12">
        <Link to="/" className="inline-flex items-center text-gray-600 hover:text-navy-500 mb-6">
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-gray-900 mb-6">About qbool</h1>
        
        <div className="prose max-w-none">
          <Card className="mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
              <p className="text-gray-700 mb-4">
                Assalamu Alaikum! qbool is a premier Islamic matrimonial service dedicated to helping 
                Muslims worldwide find their life partners in accordance with Islamic values and principles.
              </p>
              <p className="text-gray-700">
                Founded with the vision of making halal matchmaking accessible, safe, and respectful, we understand 
                the importance of finding a spouse who shares your faith, values, and life goals.
              </p>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-semibold mb-4">Our Islamic Values</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <div className="flex items-start mb-3">
                    <Shield className="w-6 h-6 text-navy-500 mr-3 mt-1" />
                    <div>
                      <h3 className="font-semibold mb-2">Halal & Respectful</h3>
                      <p className="text-gray-700">All interactions maintain Islamic guidelines with respect and dignity.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-start mb-3">
                    <Heart className="w-6 h-6 text-navy-500 mr-3 mt-1" />
                    <div>
                      <h3 className="font-semibold mb-2">Family-Focused</h3>
                      <p className="text-gray-700">We encourage family involvement in the marriage process.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-start mb-3">
                    <Users className="w-6 h-6 text-navy-500 mr-3 mt-1" />
                    <div>
                      <h3 className="font-semibold mb-2">Community Driven</h3>
                      <p className="text-gray-700">Serving the diverse Muslim community across the world.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-start mb-3">
                    <CheckCircle className="w-6 h-6 text-navy-500 mr-3 mt-1" />
                    <div>
                      <h3 className="font-semibold mb-2">Privacy Protected</h3>
                      <p className="text-gray-700">Your information is secure and used only for matchmaking.</p>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-semibold mb-4">Why Choose qbool?</h2>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-1" />
                  <span className="text-gray-700">Verified Muslim profiles from around the world</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-1" />
                  <span className="text-gray-700">Advanced search filters based on Islamic preferences</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-1" />
                  <span className="text-gray-700">Safe and secure platform maintaining Islamic etiquette</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-1" />
                  <span className="text-gray-700">Dedicated customer support team</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-r from-red-50 to-pink-50">
            <CardContent className="p-8 text-center">
              <h2 className="text-2xl font-semibold mb-6">Ready to Complete Half Your Deen?</h2>
              <Link to="/register">
                <Button className="bg-mint-500 hover:bg-mint-600 text-white px-8 py-3">
                  Register Now - It's Free!
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;